import React, { useContext } from 'react'
import { UserContext } from '../../stores/UserStore'
import { AppContext } from '../../stores/AppStore'
import Header from '../../components/layout/Header'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import AppLogo from 'assets/images/new-logo.png'

const AppHeader = () => {
  const { t } = useTranslation()
  const { pageTitle, pageSubtitle, isHeaderVisible } = useContext(AppContext)
  const { authState, signOut, currentUser } = useContext(UserContext)
  const history = useHistory()

  const sideMenuSettings = {
    appLogoSrc: AppLogo,
    itemGroups: [
      {
        key: 'no-header',
        items: [
          {
            key: 'no-header-entry',
            icon: 'apps',
            label: t('report.pageTitle'),
            onClick: () => history.push('/'),
          },
          {
            key: 'customer',
            icon: 'apps',
            label: t('customer.pageTitle'),
            onClick: () => history.push('/customer-success'),
          },
          {
            key: 'data-management',
            icon: 'apps',
            label: t('data-management.pageTitle'),
            onClick: () => history.push('/data-management'),
          },
          {
            key: 'logs',
            icon: 'apps',
            label: t('log.pageTitle'),
            onClick: () => history.push('/logs')
          }
        ],
      },
      
    ],
  }

  const userSettings = {
    username: currentUser ? currentUser.name : currentUser,
    options: [
      {
        key: 'version',
        label: 'v' + process.env.REACT_APP_VERSION,
        onClick: () => {},
      },
      {
        key: 'edit-profile',
        label: t('Edit Profile'),
        onClick: () =>
          (window.location.href =
            process.env.REACT_APP_HOME_URL + 'update-profile'),
        divider: true,
      },
      {
        key: 'sign-out',
        label: t('Sign Out'),
        onClick: signOut,
        divider: true,
      },
    ],
  }

  const home = {
    onClick: () => (window.location.href = process.env.REACT_APP_HOME_URL),
  }

  const apps =
    currentUser &&
    currentUser.applications.map((app) => {
      return {
        key: app.id,
        label: app.label,
        iconSrc: app.icon,
        onClick: () => (window.location.href = app.link),
      }
    })

  const redirectToHome = () =>
    (window.location.href = process.env.REACT_APP_HOME_URL)

  return isHeaderVisible && authState === 'SIGNED_IN' ? (
    <Header
      title={pageTitle}
      homeIcon={home}
      sideMenuSettings={sideMenuSettings}
      subtitle={pageSubtitle}
      onAppIconClick={redirectToHome}
      userSettings={userSettings}
      apps={apps}
    />
  ) : null
}

export default AppHeader
